import { Value } from '@com-delta-omnichannel/aura';

export const FlightActivityMocks: Value[] = [
  {
    amount: '$3,630',
    currency: ''
  }
];

export const AmexCardlActivityMocks: Value[] = [
  {
    amount: '$6,000',
    currency: ''
  }
];

export const JapanCardActivityMocks: Value[] = [
  {
    amount: '$1,300',
    currency: ''
  }
];

export const CarRentalActivityMocks: Value[] = [
  {
    amount: '$472',
    currency: ''
  }
];

export const StayActivityMocks: Value[] = [
  {
    amount: '$2,529',
    currency: ''
  }
];

export const VacationActivityMocks: Value[] = [
  {
    amount: '$1,418',
    currency: ''
  }
];

export const OtherActivityMocks: Value[] = [
  {
    amount: '$48',
    currency: ''
  }
];
